export default {"src":"/_next/static/media/settings-icon.8cf1d42a.svg","height":32,"width":31,"blurWidth":0,"blurHeight":0};